import React from 'react';
import locale from '@glu/locale';
import Logo from 'system/components/logos/PtxAshBig';

const notFound = () => {
  const classes = {
    errorpage: {
      top: 0,
      left: 0,
      width: '100vw',
      display: 'flex',
      position: 'absolute',
      background: 'white',
      boxSizing: 'border-box',
      minHeight: '100vh',
      paddingTop: '114px',
      paddingBottom: '48px'
    },
    container: {
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      fontFamily: '"Roboto Condensed", Roboto, Helvetica, Arial, sans-serif',
      color: '#333333',
      fontSize: '20px',
      textAlign: 'center',
      flexDirection: 'column'
    },
    logoContainer: {
      border: 'none',
      padding: '0px',
      borderRadius: '0px'
    },
    svg: {
      maxWidth: '250px'
    },
    message: {
      fontSize: '50px',
      marginTop: '41px',
      fontWeight: 300,
      lineHeight: '60px',
      marginBottom: '52px'
    },
    description: {
      lineHeight: '29px',
      marginBottom: '19px',
      textTransform: 'uppercase'
    },
    tryAgain: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      lineWeight: '26px'
    }
  };

  const text = {
    sorry: locale.get('wereSorry'),
    cantFind: locale.get('cantFindTheDocument'),
    tryAgain: locale.get('pleaseTryAgainOrContactTheSender'),
    bottomlinePtx: locale.get('bottomlinePtx')
  };

  return (
    <div style={classes.errorpage}>
      <div style={classes.container}>
        <div>
          <div style={classes.logoContainer}>
            <Logo style={classes.svg} />
          </div>
        </div>
        <div style={classes.message}>{text.sorry}</div>
        <div style={classes.description}>{text.cantFind}</div>
        <div style={classes.tryAgain}>{text.tryAgain}</div>
      </div>
    </div>
  );
};

export default notFound;